var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100 mx-auto"},[_c('VueApexCharts',{attrs:{"type":"donut","options":_vm.donutChart.options,"series":_vm.donutChart.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }